import { z } from 'zod';

export const CoreLocationScalarFieldEnumSchema = z.enum(['id','cityId','parcelNumber','locationAddressId','locationName','ownerName','ownerAddressId','ownerEmail','ownerPhone','lotSize','zoning','yearBuilt','buildingTypeId','deactivatedAt','createdAt','updatedAt','rowTimestamp','externalId']);

export default CoreLocationScalarFieldEnumSchema;
